export default __webpack_public_path__ + "static/senahasa-a40cc4d67f2f40a2b5c2f1a4bbb3b061.png";